export default "__VITE_ASSET__CiU3OhPF__"